import { cn } from '@/lib/cn'

/** Swirling void / candle-burn loading indicator (Style Guide). */
export function Loading({ label = 'Summoning…', className }: { label?: string; className?: string }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-10 text-bone-dim', className)} role="status" aria-live="polite">
      <div className="relative h-10 w-10">
        <div className="absolute inset-0 animate-void-swirl rounded-full border-2 border-blood-500/30 border-t-blood-400" />
        <div className="absolute inset-2 animate-candle-flicker rounded-full bg-gold/40 blur-[2px]" />
      </div>
      <span className="font-ui text-xs uppercase tracking-title">{label}</span>
    </div>
  )
}

/** Skeleton shimmer block. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-sm bg-obsidian-100/60', className)} />
}
